export const ROUTES = {
  home: '/',
  rCat: '/rcat',
  creditGeography: 'credit-geography',
  notFound: '/404',
};
